<template>
  <div class="container">
    <div class="row hcenter">
      <status-info
        :message="placeOrderMessage"
        status="error"
        class="sm-12 md-7"
        v-if="placeOrderApiStatus === 3"
      />
    </div>
    <div class="row hcenter">
      <div v-if="order" class="sm-12 md-7">
        <h2>User Details</h2>
        <form @submit.prevent="placeOrder" class="row">
          <input-field
            label="Contact Number"
            id="contactNumber"
            class="sm-12 md-6 pr-1 field"
            placeholder="Your contanct number"
            :value="contactNumber"
            :error="errors.contactNumber"
          />
          <input-field
            label="Shipping Address"
            id="deliveryAddress"
            class="sm-12 md-6 pl-1 field"
            placeholder="Where to ship your order"
            :error="errors.deliveryAddress"
          />

          <div class="row hvcenter mt-1">
            <button
              type="submit"
              :class="placeOrderApiStatus === 1 ? 'loading' : ''"
            >
              Place Order
            </button>
          </div>
        </form>
      </div>
      <div v-else class="sm-12 md-6">
        <h2>Payment Method</h2>
        <div id="paypal-button-container"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AppConfig } from "@/utils/variables";
import api from "@/api";

import InputField from "@/components/InputField";
import StatusInfo from "@/components/StatusInfo";

let vueInstance = null;
const makePaymentRequest = () => {
  const orderId = vueInstance.placedOrderID;
  // console.log('This: ', api)
  const payload = {
    orderId,
  };

  console.log("Payment Payload: ", payload);
  return new Promise((resolve, reject) => {
    api.post(
      "/payments/paypal/orders-create-request",
      JSON.stringify(payload),
      (data) => resolve(data),
      (error) => reject(error)
    );
  });
};
const confirmPaymentApproval = ({ orderID: paypalOrderId }) => {
  const orderId = vueInstance.placedOrderID;
  const payload = {
    orderId,
    paypalOrderId,
  };

  console.log("Paypal: ", paypalOrderId)
  return new Promise((resolve, reject) => {
    api.post(
      "/payments/paypal/orders-capture-request",
      payload,
      (data) => resolve(data),
      (error) => reject(error)
    );
  });
};

// FIXME user named functions instead of arrow functions
export default {
  name: "Checkout",
  metaInfo() {
    return {
      title: `Checkout | ${AppConfig.name}`,
    };
  },
  components: {
    InputField,
    StatusInfo,
  },
  computed: {
    ...mapGetters({
      paypalCreateRequestApiStatus: "Payments/paypalCreateRequestStatus",

      user: "User/getDetails",
      placeOrderApiStatus: "Orders/placeOrderStatus",
      placeOrderMessage: "Orders/placeOrderMessage",
      placedOrderID: "Orders/placedOrderID",
    }),
  },
  data() {
    return {
      order: true,

      contactNumber: '',
      deliveryAddress: '',

      errors: {
        contactNumber: "",
        deliveryAddress: "",
      },
    };
  },
  watch: {
    user(newUser) {
      this.handleUserFields(newUser)
    }
  },
  created() {
    const orderStatus = this.$route.params.order;
    if (orderStatus !== undefined) {
      this.order = orderStatus;
    }
  },
  mounted() {
    this.paypal = window.paypal;
    vueInstance = this;

    this.handleUserFields()
    if (!this.order) {
      this.paypal
        .Buttons({
          createOrder: this.createOrder,
          onApprove: this.onApprove,
        })
        .render("#paypal-button-container");
    }
  },
  methods: {
    handleUserFields(user = this.user) {
      console.log(user)
      this.contactNumber = user.phoneNumber
    },

    placeOrder(e) {
      const form = new FormData(e.target);
      const contactNumber = form.get("contactNumber");
      const deliveryAddress = form.get("deliveryAddress");

      if (contactNumber === "") {
        this.errors.contactNumber = "You must provide your contact number";
      } else {
        this.errors.contactNumber = "";
      }
      if (deliveryAddress === "") {
        this.errors.deliveryAddress = "You must provide a shipping address";
      } else {
        this.errors.deliveryAddress = "";
      }

      if (this.errors.contactNumber || this.errors.deliveryAddress) {
        return;
      }

      const payload = {
        contactNumber,
        deliveryAddress,
      };
      this.$store.dispatch("Orders/placeOrder", payload).then(() => {
        if (this.placeOrderApiStatus === 2) {
          // this.$router.push({ name: 'Checkout' })
          this.order = false;

          setTimeout(() => {
            this.paypal
              .Buttons({
                createOrder: this.createOrder,
                onApprove: this.onApprove,
              })
              .render("#paypal-button-container");
          }, 1000);
        }
      });

      console.log(payload);
    },

    createOrder: async () => {
      // console.clear();
      // console.log('This: ', vueInstance)

      try {
        const response = await makePaymentRequest();
        const paypalOrderId = response.data.data.paypalOrderId;
        // console.log("Paypal Order ID: ", paypalOrderId);
        return paypalOrderId;
      } catch (e) {
        console.log("Error", e);
        window.e = e;
      }
    },
    onApprove: async (data) => {
      // console.log("On Approve data ->", data);

      try {
        await confirmPaymentApproval(data);
        vueInstance.$store.dispatch('Cart/reset');
        vueInstance.$router.push({ name: "Home" });
      } catch (e) {
        console.log("Error");
        window.e = e.response.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@include mobile-only {
  .field {
    padding: 0;
  }
}
</style>